import React, { useEffect, useState } from "react";
import JobDropdown from "../jobDropdown";
import { IoArrowForward } from "react-icons/io5";
import { BsPencil } from "react-icons/bs";
import "../../index.css";
// import { Input } from "antd";
import { Input, Select, Tooltip, DatePicker, TimePicker } from "antd";
import { toast } from "react-toastify";
import moment from "moment";
// import { DatePicker } from 'antd';
import Cookies from "universal-cookie";
import { useCan } from "../../../../utils/permissions";
import { Button } from "antd";
const { Option } = Select;
const formatDate = (isoString) => {
  const date = new Date(isoString);
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: true,
  });
};
const Index = ({
  arg: {
    activeEdit,
    singleWorkOrder,
    setSingleWorkOrder,
    apptDate,
    apptTime,
    setapptDate,
    setapptTime,
    updateValidationMessage,
    validationMessage,
    numberOfDevice,
    tranId,
    surveys,
  },
}) => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  // const [apptDate, setApptDate] = useState(null);
  // console.log("isVisibleTech---->",isVisibleTech)
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showTimePicker, setShowTimePicker] = useState(false);
  // const [validationMessage, setValidationMessage] = useState('');
  const can = useCan();
  const canDeleteUser = can("workOrders", "update");
  const userData = JSON.parse(localStorage.getItem("userData"));
  const roleName = userData?.roleDetails?.name

  const cookies = new Cookies();
  const token = cookies.get("token");

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API}/user/getalluser`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.ok) {
          const userData = await response.json();
          setUsers(userData.technicians);
          // console.log("userData---------->",userData)
        } else {
          throw new Error("Failed to fetch users");
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    // if (showUserList) {
    fetchUsers();
    // }
  }, [singleWorkOrder]);

  useEffect(() => {
    if ((apptDate && apptTime) || (!apptDate && !apptTime)) {
      updateValidationMessage("");
    } else {
      updateValidationMessage(
        "appointment date and time both must be specified, or leave them blank."
      );
    }
  }, [apptDate, apptTime]);

  const handleUserSelect = (value) => {
    const selected = users.find((user) => user.techId === value);
    // console.log("selected", selected)
    setSelectedUser(selected);
    // Handle the selected user (e.g., update state, show a message, etc.)
  };

  const assignTechnician = async () => {
    if (selectedUser) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API}/workOrders/assignTechnician`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              tranId: singleWorkOrder.tranId,
              userId: selectedUser._id,
              name: selectedUser.name,
              techId: selectedUser.techId,
            }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to assign technician");
        }
        const result = await response.json();
        console.log("Technician assigned!", result);
        setSingleWorkOrder((prevState) => ({
          ...prevState,
          techName: selectedUser.name,
          techId: selectedUser.techId,
          userId: selectedUser._id,
        }));
        toast.success("Technician assigned successfully");
      } catch (error) {
        console.error("Error assigning technician:", error);
        toast.error("Unable to assing technician, try again later.");
      }
    } else {
      console.error("No technician selected");
    }
  };

  const removeTechnician = async () => {
    if (singleWorkOrder?.tranId) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API}/workOrders/removeTechnician`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ tranId: singleWorkOrder.tranId }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to remove technician");
        }

        setSingleWorkOrder((prevState) => ({
          ...prevState,
          techName: null,
          userId: null,
          techId: null,
        }));
        console.log("technician removed!", response);

        toast.success("Technician removed successfully");
      } catch (error) {
        console.error("Error removing technician:", error);
        toast.error("Unable to remove technician, try again later.");
      }
    }
  };

  return (
    <div>
      <div className="mt-2">
        <div className="row position-relative">
          <div className="col-lg-2 col-md-4 col-sm-12 sub2head">TECH</div>
          <div className="col-lg-10 col-md-8 col-sm-12 d-flex gap-2 position-relative">
            {singleWorkOrder?.techName == null ? (
              <Select
                // className="form-control"
                defaultValue={singleWorkOrder?.techName || ""}
                onChange={handleUserSelect}
                style={{ width: "100%" }}
                className="mt-1"
              >
                {users &&
                  users.map((user, i) => (
                    <Option key={user.techId + i} value={user.techId}>
                      {user.name} {"(" + user.email + ")"}
                    </Option>
                  ))}
              </Select>
            ) : (
              <input
                className={`form-control ${singleWorkOrder?.techName ? "activewidth" : ""
                  }`}
                value={singleWorkOrder?.techName}
                readOnly
              />
            )}

          {singleWorkOrder.techName !== null ? (
            (roleName === "admin" || roleName === "Admin"  || roleName === "Manager" || roleName === "manager") ? (
              <Button
                className="removebtn"
                onClick={removeTechnician}
                disabled={!canDeleteUser}
              >
                Remove Technician from Order
              </Button>
            ) : null
            ) : (
              <div className="position-absolute end-0 mb-5">
                <Tooltip title="Assing Technician">
                  <IoArrowForward
                    className="arrcls"
                    onClick={assignTechnician}
                  />
                </Tooltip>
              </div>
            )}
            {/* {isVisibleTech ? (
              ""
            ) : (
              <IoArrowForward className="arrcls" onClick={handleClickTech} />
            )}
            {isVisibleTech && (
              <button className="removebtn" onClick={removeTechnician}>
                Remove Technician from Order
              </button>
            )} */}
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-lg-2 col-md-4 col-sm-12 sub2head">JOB TYPE</div>
          <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
            <Input
              value={singleWorkOrder?.jobType}
              disabled={!activeEdit}
              className="form-control"
              onChange={(e) => {
                // Assuming you have a function to update the jobType in your state
                // This is just a placeholder, replace it with your actual state update logic
                setSingleWorkOrder((prevState) => ({
                  ...prevState,
                  jobType: e.target.value,
                }));
              }}
            />
            {activeEdit && (
              <div className="position-absolute end-0 top-0 pt-4">
                <BsPencil className="icon_dis" />
              </div>
            )}
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-lg-2 col-md-4 col-sm-12 sub2head">Owner</div>
          <div className="col-lg-10 col-md-8 col-sm-12">
            <Input
              className="form-control"
              readOnly
              disabled={!activeEdit}
              value={singleWorkOrder?.owner}
            />
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-lg-2 col-md-4 col-sm-12 sub2head">Appt Date</div>
          <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
            {showDatePicker ? (
              <DatePicker
                className="form-control"
                disabled={!activeEdit}
                format="MM/DD/YYYY" // Set the desired format for the DatePicker
                onChange={(date, dateString) => {
                  setShowDatePicker(false); // Close DatePicker after selecting a date
                  // Update the value in the state without changing the format
                  // setSingleWorkOrder(prevState => ({
                  //   ...prevState,
                  //   apptDate: date.toISOString() // Assuming dateString is in MM/DD/YYYY format
                  // }));
                  setapptDate(dateString);
                }}
              />
            ) : (
              <Input
                className="form-control"
                disabled={!activeEdit}
                value={
                  apptDate !== ""
                    ? new Date(apptDate).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    })
                    : "Select Date"
                }
                onClick={() => {
                  setShowDatePicker(true);
                  setapptDate("");
                }} // Show DatePicker when the input is clicked
              />
            )}
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-lg-2 col-md-4 col-sm-12 sub2head">Appt Time</div>
          <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
            {showTimePicker ? (
              <TimePicker
                className="form-control"
                disabled={!activeEdit}
                format="HH:mm a"
                onChange={(time, timeString) => {
                  setShowTimePicker(false);
                  // Assuming you want to update the apptDate state with the new time
                  //  setSingleWorkOrder(prevState => ({
                  //    ...prevState,
                  //    apptDate: time.toISOString() // Update the apptDate with the new time
                  //  }));
                  const formattedTimeString = moment(
                    timeString,
                    "hh:mm a"
                  ).format("hh:mm a");
                  setapptTime(formattedTimeString);
                }}
              // value={singleWorkOrder?.apptDate ? moment(singleWorkOrder.apptDate, 'HH:mm') : null}
              />
            ) : (
              <Input
                className="form-control"
                disabled={!activeEdit}
                // disabled={!activeEdit}
                // value={new Intl.DateTimeFormat('en-US', {
                //   hour: '2-digit',
                //   minute: '2-digit',
                //   hour12: true,
                //   timeZone: 'America/New_York', // Replace with the desired timezone
                //   timeZoneName: 'short'
                // }).format(new Date(singleWorkOrder?.apptDate))}
                value={
                  apptTime !== ""
                    ? moment(apptTime, "hh:mm a").format("hh:mm a")
                    : "Select Time"
                }
                // value={apptTime}
                onClick={() => {
                  setShowTimePicker(true);
                  setapptTime("");
                }}
              />
            )}
          </div>
        </div>
        {validationMessage && (
          <div className="row mt-2">
            <div className="col-lg-2 col-md-4 col-sm-12 sub2head"></div>
            <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
              <div className="alert alert-danger mt-2" role="alert">
                {validationMessage}
              </div>
            </div>
          </div>
        )}

        <div className="row mt-2">
          <div className="col-lg-2 col-md-4 col-sm-12 sub2head">Address</div>
          <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
            <Input
              className="form-control"
              disabled={!activeEdit}
              value={singleWorkOrder?.address}
              onChange={(e) => {
                // Assuming you have a function to update the jobType in your state
                // This is just a placeholder, replace it with your actual state update logic
                setSingleWorkOrder((prevState) => ({
                  ...prevState,
                  address: e.target.value,
                }));
              }}
            />
            {activeEdit && (
              <div className="position-absolute end-0 top-0 pt-4">
                <BsPencil className="icon_dis" />
              </div>
            )}
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-lg-2 col-md-4 col-sm-12 sub2head">Phone</div>
          <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
            <Input
              className="form-control"
              value={singleWorkOrder?.phone}
              disabled={!activeEdit}
              onChange={(e) => {
                // Assuming you have a function to update the jobType in your state
                // This is just a placeholder, replace it with your actual state update logic
                setSingleWorkOrder((prevState) => ({
                  ...prevState,
                  phone: e.target.value,
                }));
              }}
            />
            {activeEdit && (
              <div className="position-absolute end-0 top-0 pt-4">
                <BsPencil className="icon_dis" />
              </div>
            )}
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-lg-2 col-md-4 col-sm-12 sub2head">Tracking </div>
          <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
            <Input
              className="form-control"
              value={singleWorkOrder?.custbodyBgSdTracking}
              readOnly
              disabled={!activeEdit}
            />
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-lg-2 col-md-4 col-sm-12 sub2head">
            Appt Status
          </div>
          <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
            <Select
              // className="form-control"
              style={{ width: "100%" }}
              value={singleWorkOrder?.apptStatus || ""}
              onChange={(value) => {
                setSingleWorkOrder((prevState) => ({
                  ...prevState,
                  apptStatus: value,
                }));
                // console.log("Selected Appointment Status:", value);
              }}
              disabled={!activeEdit}
            >
              <Option value="scheduled">Scheduled</Option>
              <Option value="rejected">Rejected</Option>
              <Option value="pending">Pending</Option>
              <Option value="onhold">On Hold</Option>
              <Option value="rescheduled">Rescheduled</Option>
              <Option value="Partially Completed">Partially Completed</Option>
              <Option value="Order Fix Needed">Order Fix Needed</Option>
              <Option value="completed">Completed</Option>
              <Option value="cancelled">Cancelled</Option>
            </Select>
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-lg-2 col-md-4 col-sm-12 sub2head">Start Job Time </div>
          <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
            <Input
              className="form-control"
              value={singleWorkOrder?.woStartTime ? formatDate(singleWorkOrder?.woStartTime) : null}
              readOnly
              disabled={!activeEdit}
            />
          </div>
        </div>
        {/*  Number of survey section starts from here */}
        {/* <div className="row mt-2">

          <div className="col-lg-2 col-md-4 col-sm-12 sub2head">
            Number Of Survey
          </div>
          <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
            <Input
              className="form-control"
              disabled={!activeEdit}
              value={surveys.length}
            />
          </div>
        </div> */}
        {/*  Number of survey section ends here */}

        {/*  Number of Device section starts from here */}
        {/* <div className="row mt-2">

          <div className="col-lg-2 col-md-4 col-sm-12 sub2head">
            Number Of Device
          </div>
          <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
            <Input
              className="form-control"
              disabled={!activeEdit}
              value={numberOfDevice.length}
            />
          </div>
        </div> */}

        {/*  Number of Device section ends here */}
      </div>
    </div>
  );
};

export default Index;
